<template>
  <div>
    <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
      <md-card >
        <md-card-header class="hide-mobile" data-background-color="newyellow">
          <div style="display: flex;align-items: center;">
            <md-icon class="configicon">archive</md-icon>
            <h4 class="tittle">Arquivos</h4>
          </div>
        </md-card-header>
        <md-card-content>
        
          <div class="tabsarq">
            <v-tabs
              v-model="tab"
              background-color="deep-purple accent-4"
              class="elevation-2"
              dark
              :centered="centered"
              :grow="grow"
              :vertical="vertical"
              :icons-and-text="icons"
            >
              <v-tabs-slider></v-tabs-slider>

              <v-tab height="50px" v-for="i in tabs" :key="i.id" :href="`#tab-${i.id}`">
                <div style="display: flex;">
                  <span>
                    <md-icon>{{ i.icon }}</md-icon>
                    {{ i.name }}
                  </span>
                </div>
              </v-tab>

              <v-tab-item v-for="i in tabs" :key="i.id" :value="'tab-' + i.id">
                 <ListaArquivos v-if="tab== 'tab-0'" />
                 <UploadArquivos v-if="tab == 'tab-1'" />
              </v-tab-item>
            </v-tabs>
          </div>
        </md-card-content>
      </md-card>
    </div>
  </div>
</template>
<script>
import ListaArquivos from "../components/Arquivos/ListaArquivos";
import UploadArquivos from "../components/Arquivos/UploadArquivos";
export default {
  components: {
    ListaArquivos,
    UploadArquivos
  },
  data() {
    return {
      tab: null,
      text:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
      icons: true,
      centered: false,
      grow: false,
      vertical: true,
      tabs: [
        { icon: "list", name: "Lista de Arquivos", id: 0 },
        { icon: "backup", name: "Upload de Arquivo", id:1 }
      ]
    };
  }, created(){
    this.tab = { icon: "list", name: "Lista de Arquivos", id: 0 }
  }
};
</script>
<style scoped>
.configicon {
  width: 20px;
  margin: 3px;
  margin-right: 19px;
  color: #fff !important;
  font-size: 36px !important;
}
</style>
<style>
.tabsarq .v-tabs__container--icons-and-text {
  height: 35px;
  padding-top: 4px;
  background: #fff;
}
.tabsarq .v-tabs.elevation-2 {
  box-shadow: none!important;
}
.v-tabs__item{
  color: #000!important;
}
</style>